import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { NgFor } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-enum-select',
    templateUrl: './enum-select.component.html',
    styleUrls: ['./enum-select.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HxEnumSelectComponent),
            multi: true
        }],
    imports: [NgSelectComponent, FormsModule, NgFor, NgOptionComponent, TranslocoPipe]
})
export class HxEnumSelectComponent implements OnInit, OnChanges, ControlValueAccessor {

  @Input() multiple = false;
  @Input() enumType!: any;
  @Input() enumName!: string;
  @Input() isDisabled = false;
  @Input() exclude: string[] = [];
  @Output() selectChange = new EventEmitter<string | string[] | undefined>();

  options: string[] = [];
  private $selected?: string | string[];

  get selected(): string | string[] | undefined {
    return this.$selected;
  }

  set selected(val: string | string[] | undefined) {
    this.$selected = val;
    this.onChange(this.$selected);
  }

  ngOnInit(): void {
    this.options = Object.keys(this.enumType).filter(type => !this.exclude.includes(type)).map((pt) => this.enumType[pt]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['exclude']) {
      let find;
      if (!this.multiple) {
        if (this.selected) {
          find = this.exclude.find(p => p === this.selected);
          if (find) {
            this.selected = undefined;
          }
        }
      } else {
        if (Array.isArray(this.selected)) {
          const selectedIds: string[] = this.selected;
          find = this.exclude.find(r => selectedIds.includes(r));
          if (find) {
            this.selected = [];
          }
        } else {
          this.selected = [];
        }
      }
      this.options = Object.keys(this.enumType).filter(type => !this.exclude.includes(type)).map((pt) => this.enumType[pt]);
    }
  }

  onModelChanged(val: any) {
    if (!this.multiple) {
      if (this.selected) {
        this.selectChange.emit(this.options.find(p => p === this.selected));
      } else {
        this.selectChange.emit();
      }
    } else {
      if (Array.isArray(this.selected)) {
        const ids: string[] = this.selected;
        this.selectChange.emit(this.options.filter(p => ids.includes(p)));
      } else {
        this.selectChange.emit([]);
      }
    }
  }

  onChange(val: any) {
    // console.log('onChange called', val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(obj?: string | string[]): void {
    this.selected = obj;
  }
}
